import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {TextField} from "@material-ui/core";
import ControlledSelect from "./controlledSelect";
import MultiControlledIdOptionSelect from "./multiControlledIdOptionSelect";
import {formatInputDate} from "../utils/formatInputDate";

export default function CreateFooterNoteDialog({
                                                   open,
                                                   handleClose,
                                                   data,
                                                   onChange,
                                                   handleFormSubmit,
                                                   constantsData,
                                                   country
                                               }) {
    const onDateChange = (e) => {
        const {id, value} = e.target;
        const formattedValue = formatInputDate(value);
        onChange({target: {id, value: formattedValue}});
    };
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xs"
                PaperProps={{style: {width: "600px"}}}
            >
                <DialogTitle id="alert-dialog-title">
                    Create Footer Note
                </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleFormSubmit}>
                        <TextField
                            type="text"
                            id="text"
                            value={data.text.value}
                            onChange={(e) => onChange(e)}
                            label="Text"
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            multiline
                            rows={4}
                            maxRows={8}
                            inputProps={{
                                style: {
                                    minHeight: '20px'
                                }
                            }}
                            helperText="Enter detailed footer note text here"
                            required={true}
                        />
                        {
                            country === "CA" ?
                                (<TextField
                                type="frText"
                                id="frText"
                                value={data.frText.value}
                                onChange={(e) => onChange(e)}
                                label="French Transaltion"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                multiline
                                rows={4}
                                maxRows={8}
                                inputProps={{
                                    style: {
                                        minHeight: '20px'
                                    }
                                }}
                                helperText="Enter french transaltion here"
                                required={country === "CA"}
                            />): null
                        }
                        <ControlledSelect
                            id={"documentType"}
                            label="Select Document Type"
                            value={data.documentType.value}
                            options={
                                constantsData.footerNotesDocumentTypes?.map(
                                    (option) => ({
                                        label: option?.name,
                                        value: option,
                                    }),
                                ) || []
                            }
                            onChange={onChange}
                            hasError={data.documentType.hasError}
                            includeAllFlag="false"
                            isRequired={true}
                        />
                        <MultiControlledIdOptionSelect
                            id="titleStatus"
                            label="Select Title Status"
                            value={data.titleStatus.value}
                            options={
                                [{_id: "ALL", name: "All"}, ...constantsData?.titleStatus]
                            }
                            onChange={onChange}
                            isRequired={false}
                            renderAllOption={true}
                        />
                        <MultiControlledIdOptionSelect
                            id="vehicleModel"
                            label="Select Vehicle Model"
                            value={data.vehicleModel.value}
                            options={
                                [{_id: "ALL", name: "All"}, ...constantsData?.vehicleModel]
                            }
                            onChange={onChange}
                            isRequired={false}
                            renderAllOption={true}
                        />
                        <TextField
                            id="startDate"
                            label="Start Date (MM/DD/YYYY)"
                            type="text"
                            value={data.startDate.value}
                            onChange={(e) => onDateChange(e)}
                            placeholder="Enter Start Date"
                            variant="outlined"
                            margin="dense"
                            fullWidth
                        />
                        <TextField
                            id="endDate"
                            label="End Date (MM/DD/YYYY)"
                            type="text"
                            value={data.endDate.value}
                            onChange={(e) => onDateChange(e)}
                            placeholder="Enter End Date"
                            variant="outlined"
                            margin="dense"
                            fullWidth
                        />
                        <ControlledSelect
                            id={"dateMatchField"}
                            label="Select Date Match Field"
                            value={data.dateMatchField.value}
                            options={
                                constantsData.footerNotesMatchFields?.map(
                                    (option) => ({
                                        label: option?.name,
                                        value: option,
                                    }),
                                ) || []
                            }
                            onChange={onChange}
                            hasError={data.dateMatchField.hasError}
                            includeAllFlag="false"
                        />
                        <DialogActions>
                            <Button
                                onClick={handleClose}
                                color="secondary"
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                variant="contained"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        </div>
    );
}
